// ── Design tokens ─────────────────────────────────────────────────────────────
// Edit these to change the look of the entire SDK UI in one place.

export const P      = '#7FD4E8';  // primary-light  (CSS: --ts-primary-light)
export const PDK    = '#1F6F8F';  // primary-dark   (CSS: --ts-primary-dark)
// Semantic neutrals resolve through CSS custom properties so the whole UI flips
// with the theme (auto: prefers-color-scheme; forced via colorScheme config).
export const TEXT   = 'var(--ts-text)';    // headings & emphasis
export const BODY   = 'var(--ts-body)';    // body copy
export const MUTED  = 'var(--ts-muted)';   // secondary / hint text
export const BORDER = 'var(--ts-border)';  // hairlines & input borders
export const BG     = 'var(--ts-bg)';      // subtle surface fills
export const ERR    = 'var(--ts-error)';   // destructive / errors
export const FONT   = "-apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif";
